import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { STRUCTURED_CONTENT_WREX_EDITOR_CLASSNAME } from '@lumapps/structured-content/constants';
import { BLOCK_STRUCTURED_CONTENT_CLASSNAME } from '@lumapps/widget-contribution/constants';
import {
    BLOCK_HTML_CLASSNAME,
    LEGACY_BLOCK_HTML_CLASSNAME,
    LEGACY_EDITION_HTML_CLASSNAME,
} from '@lumapps/widget-html/constants';
import {
    BLOCK_INTRO_CLASSNAME,
    EDITION_INTRO_TEXTAREA_CLASSNAME,
    LEGACY_BLOCK_INTRO_CLASSNAME,
    LEGACY_EDITION_INTRO_CLASSNAME,
    CLASSNAME as WIDGET_INTRO_CLASSNAME,
} from '@lumapps/widget-intro/constants';

import { formatTextToSummarize } from '../utils/formatTextToSummarize';

/**
 * Get the text to summarize from the textual widgets rendered in the page.
 * The legacy editor mirrors its live content to the DOM, so the rendered text is up to date.
 */
export const useDomTextToSummarize = () => {
    const widgetIntroClassname = useClassnames(WIDGET_INTRO_CLASSNAME);
    const blockHtmlClassname = useClassnames(BLOCK_HTML_CLASSNAME);

    return React.useCallback(() => {
        const elements = document.querySelectorAll(
            `.${blockHtmlClassname.block()}, .${LEGACY_BLOCK_HTML_CLASSNAME}, .${LEGACY_EDITION_HTML_CLASSNAME} .fr-element, .${BLOCK_STRUCTURED_CONTENT_CLASSNAME}, .${STRUCTURED_CONTENT_WREX_EDITOR_CLASSNAME}, .${BLOCK_INTRO_CLASSNAME}, .${widgetIntroClassname.element(
                EDITION_INTRO_TEXTAREA_CLASSNAME,
            )} textarea, .${LEGACY_BLOCK_INTRO_CLASSNAME}, .${LEGACY_EDITION_INTRO_CLASSNAME} .fr-element`,
        );

        const texts = Array.from(elements).map((element) => {
            // Rich text keeps a placeholder in the DOM while empty
            if (element.querySelector('[data-slate-placeholder="true"]')) {
                return '';
            }

            // Use innerText if available, otherwise use value
            return ((element as HTMLElement).innerText || (element as HTMLTextAreaElement).value || '').trim();
        });

        return formatTextToSummarize(texts);
    }, [blockHtmlClassname, widgetIntroClassname]);
};
